/* eslint-disable react/prop-types */
import { ExpandOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import Table from 'components/Table';
import React from 'react';

const { Title } = Typography;

const TablaCargos = ({
  cargos,
  columns,
  rowSelection,
  handleOnRowClick,
  onClickExpand,
  hasAllViewPermission,
  permission,
}) => {
  // Eliminar cargos duplicados basándose en el ID
  const _cargos = cargos.filter((cargo, index, self) => index === self
    .findIndex((c) => c.id === cargo.id));

  return (
    <>
      <Title level={4}>
        Cargos
      </Title>
      <Table
        cols={columns}
        data={_cargos}
        rowSelection={rowSelection}
        handleOnRowClick={handleOnRowClick}
        allowSearch={false}
        rowKey="id"
        customActions={[
          {
            text: 'Ver detalles de gastos',
            icon: <ExpandOutlined />,
            onClick: onClickExpand,
          },
        ]}
        hasAllViewPermission={hasAllViewPermission}
        permission={permission}
      />
    </>
  );
};

export default TablaCargos;
